import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import type { ProductListItemModel } from 'autogen/swagger/all';
import DynamicItemCarousel from 'components/generic/ScrollSnapSlider/components/DynamicItemCarousel';
import ProductItem from 'components/shared/productItem';
import useIsMobile from 'hooks/responsive/useIsMobile';
import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';

const CarouselOverflowContainer = styled.div`
    position: relative;
    margin: 0 -${Spacing16};
    min-width: 0;

    ${breakpoint.up(sizes.xl)} {
        margin: 0;
    }
`;

const scrollContainerStyling = css`
    && {
        gap: ${Spacing16};
        padding: 0 ${Spacing16};
        scroll-padding-inline-end: ${Spacing16};
        scroll-padding-inline-start: ${Spacing16};

        ${breakpoint.up(sizes.sm)} {
            gap: ${Spacing24};
        }

        ${breakpoint.up(sizes.xl)} {
            scroll-padding-inline-end: 0;
            scroll-padding-inline-start: 0;
            padding: 0;
        }
    }
`;

export default function ProductSlider({ items }: { items: ProductListItemModel[] }) {
    const isMobile = useIsMobile();

    return (
        <CarouselOverflowContainer>
            <DynamicItemCarousel
                gapSize={isMobile ? Spacing16 : Spacing24}
                scrollContainerCss={scrollContainerStyling}
                items={items}
                itemRenderer={(item, index) => <ProductItem model={item} key={index} data-slide-index={index} />}
                nextItemMobileIndentation="60px"
            />
        </CarouselOverflowContainer>
    );
}
